import { createUseStyles } from 'react-jss';
import { hideScrollbars, mozScrollbars } from '@picsart/rc/helpers';

import { StackingContext } from 'utils/ui-helpers/stackingContexts';

import { ModalHorizontalPosition } from './types';

const useStyles = createUseStyles(
  {
    root: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: props => props.backgroundColor,
      overflowX: 'hidden',
      overflowY: 'auto',
      ...mozScrollbars(),
      ...hideScrollbars,
      scrollBehavior: 'smooth',
      zIndex: props => props.zIndex || StackingContext.Base,
    },
    backLayer: {
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    container: {
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      height: '100%',
    },
    row: {
      display: 'table-row',
      height: '100%',
    },
    cell: props => {
      const styles = {
        display: 'table-cell',
        height: '100%',
        verticalAlign: props.verticalPosition,
        textAlign: !props.contentIsFullWidth && props.horizontalPosition,
      };

      let horizontalStyles: object;

      switch (props.horizontalPosition) {
        case ModalHorizontalPosition.Left:
          horizontalStyles = {
            textAlign: 'start',
          };
          break;
        case ModalHorizontalPosition.Right:
          horizontalStyles = {
            textAlign: 'end',
          };
          break;
        case ModalHorizontalPosition.Center:
          horizontalStyles = {
            textAlign: 'center',
          };
          break;
        default:
          horizontalStyles = {};
          break;
      }

      return {
        ...styles,
        ...horizontalStyles,
      };
    },
    content: {
      display: 'inline-block',
      verticalAlign: 'top',
      textAlign: 'initial',
      width: props => props.contentIsFullWidth && '100%',
      height: props => props.contentIsFullHeight && '100%',
      position: 'relative',
    },
  },
  {
    name: 'modal',
  },
);
export default useStyles;
